export const GET_INVESTMENTS_STARTED = 'GET_INVESTMENTS_STARTED'
export const GET_INVESTMENTS_SUCCESS = 'GET_INVESTMENTS_SUCCESS'
export const GET_INVESTMENTS_FAILURE = 'GET_INVESTMENTS_FAILURE'

export const EDIT_PROFILE_STARTED = 'EDIT_PROFILE_STARTED'
export const EDIT_PROFILE_SUCCESS = 'EDIT_PROFILE_SUCCESS'
export const EDIT_PROFILE_FAILURE = 'EDIT_PROFILE_FAILURE'

export const POST_REQUEST_INVESTMENT_STARTED = 'POST_REQUEST_INVESTMENT_STARTED'
export const POST_REQUEST_INVESTMENT_SUCCESS = 'POST_REQUEST_INVESTMENT_SUCCESS'
export const POST_REQUEST_INVESTMENT_FAILURE = 'POST_REQUEST_INVESTMENT_FAILURE'


export const APPLY_FILTER_INVESTMENTS_STARTED = 'APPLY_FILTER_INVESTMENTS_STARTED'
export const APPLY_FILTER_INVESTMENTS_SUCCESS = 'APPLY_FILTER_INVESTMENTS_SUCCESS'
export const APPLY_FILTER_INVESTMENTS_FAILURE = 'APPLY_FILTER_INVESTMENTS_FAILURE'

export const GET_FIRSTTIMECHECKTNC_STARTED = 'GET_FIRSTTIMECHECKTNC_STARTED'
export const GET_FIRSTTIMECHECKTNC_SUCCESS = 'GET_FIRSTTIMECHECKTNC_SUCCESS'
export const GET_FIRSTTIMECHECKTNC_FAILURE = 'GET_FIRSTTIMECHECKTNC_FAILURE'

export const GET_UPDATE_TERM_AND_CONDTION_ACCEPTANCE_STARTED = 'GET_UPDATE_TERM_AND_CONDTION_ACCEPTANCE_STARTED'
export const GET_UPDATE_TERM_AND_CONDTION_ACCEPTANCE_SUCCESS = 'GET_UPDATE_TERM_AND_CONDTION_ACCEPTANCE_SUCCESS'
export const GET_UPDATE_TERM_AND_CONDTION_ACCEPTANCE_FAILURE = 'GET_UPDATE_TERM_AND_CONDTION_ACCEPTANCE_FAILURE'

export const POST_ADD_COUNTRY_ACCEPTANCE_STARTED = 'POST_ADD_COUNTRY_ACCEPTANCE_STARTED'
export const POST_ADD_COUNTRY_ACCEPTANCE_SUCCESS = 'POST_ADD_COUNTRY_ACCEPTANCE_SUCCESS'
export const POST_ADD_COUNTRY_ACCEPTANCE_FAILURE = 'POST_ADD_COUNTRY_ACCEPTANCE_FAILURE'

export const GET_FIRST_TIME_CHECK_COUNTRY_STARTED = 'GET_FIRST_TIME_CHECK_COUNTRY_STARTED'
export const GET_FIRST_TIME_CHECK_COUNTRY_SUCCESS = 'GET_FIRST_TIME_CHECK_COUNTRY_SUCCESS'
export const GET_FIRST_TIME_CHECK_COUNTRY_FAILURE = 'GET_FIRST_TIME_CHECK_COUNTRY_FAILURE'


export const SEARCH_USER_STARTED = 'SEARCH_USER_STARTED'
export const SEARCH_USER_SUCCESS = 'SEARCH_USER_SUCCESS'
export const SEARCH_USER_FAILURE = 'SEARCH_USER_FAILURE'